<template>
    <div>
        <!--记一笔明细-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline :label-width="80" >
                        <FormItem  label="选择时间">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate">
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="结算类型">
                            <Select v-model="sendType" style="width: 200px">
                                <Option value="">全部</Option>
                                <Option :value="k.id" v-for="(k,v) in sendTypeList" :key="v">{{k.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem  label="结算账户">
                            <Select v-model="sendWhere"  style="width: 200px">
                                <Option value="">全部</Option>
                                <Option :value="k.id" v-for="(k,v) in bankList" :key="v">{{k.bankname}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem  label="收入支出">
                            <Select v-model="isAccess"  style="width: 200px">
                                <Option value="">全部</Option>
                                <Option value="0">收入</Option>
                                <Option value="1">支出</Option>
                            </Select>
                             <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">

            <template slot-scope="{ row, index }" slot="money">
                <span style="color: #ff9800" v-if="row.money<0">{{row.money}}</span>
                <span style="color: #009688" v-else>{{row.money}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="edit">
                <Button type="primary" size="small" @click="$router.push({path:'/RememberDetail',query:{id:row.id}})">查看</Button>
            </template>
        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                ds:false,
                columns: [
                    {title: '结算类型', key: 'tradetypename',align:'center'},
                    {title: '结算账户', key: 'bankname',align:'center' },
                    {title: '结算金额', key: 'money' ,align:'center', slot:"money"},
                    {title: '开据人', key: 'username' ,align:'center' },
                    {title: '日期', key: 'time',align:'center'  },
                    {title: '操作', key: 'edit' ,align:'center', slot:"edit" },
                ],
                data: [],
                dataTotl:{},
                page:{
                    total:0,
                    page:1,
                    rows:15
                },
                loadingTable:true,
                sendType:'',
                sendWhere:'',
                isAccess:'',//收入支出
                bankList:[],
                sendTypeList:[],
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(-30)
            this.valuedate[1] = this.nowTime
            this.getAccountsList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            this.getBankList()
            this.getTradetypeList()
        },
        watch: {
            'sendType': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getAccountsList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
                }
            },
            'sendWhere': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getAccountsList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
                }
            },
            'isAccess': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getAccountsList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
                }
            },
        },
        methods: {


            //获取列表
            getAccountsList(startTime,endTime,page,rows){
                this.$Api.getAccountsList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime:endTime,
                    tradetypeid:this.sendType,
                    bankid:this.sendWhere,
                    casher:this.isAccess,//0/结算金额 1》0   1《0
            }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.page.total = res.count
                        res.data.forEach((item,index)=> {
                            if (item.tradetypename != '销售退货' && item.tradetypename != '销售收入' && item.tradetypename != '采购支出' && item.tradetypename != '采购退货') {
                                var PurchaseList = {}
                                PurchaseList.id = item.id,
                                PurchaseList.tradetypename = item.tradetypename
                                PurchaseList.bankname = item.bankname,
                                PurchaseList.money = item.money,
                                PurchaseList.remark = item.remark,
                                PurchaseList.adminName = item.adminName,
                                PurchaseList.time = item.time
                                PurchaseList.username = JSON.parse(localStorage.getItem('adminUser')).name
                                PurchaseList.img = item.img
                               this.data.push(PurchaseList)
                            }

                        })
                        this.loadingTable=false
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getAccountsList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            onGongPageTotal(num){
                this.getAccountsList(this.valuedate[0],this.valuedate[1],num,this.page.rows)
            },
            //搜索
            searchCondition(){
                this.getAccountsList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            //获取银行卡
            getBankList(){
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.bankList =  res.data

                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //结算类型
            getTradetypeList(){
                this.$Api.getTradetypeList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        res.data.forEach((item,index)=>{
                            if(item.name!='销售退货' && item.name!='销售收入' && item.name!='采购支出' && item.name!='采购退货' ){
                                this.sendTypeList.push(item)
                            }
                        })
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //查看图片
            see(row){
                this.isShowdalog=true
                this.imglist=row.img.split(',')
            },
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }

</style>